import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { WA } from '../../constants';
import { ExternalLink } from '../ui';

const WhatsAppFloat = () => {
  return (
    <ExternalLink 
      href={WA} 
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 w-14 h-14 sm:w-16 sm:h-16 bg-green-500 rounded-full flex items-center justify-center shadow-lg shadow-green-500/30 hover:scale-110 active:scale-95 transition-transform z-50" 
      aria-label="WhatsApp"
    >
      <FontAwesomeIcon icon={faWhatsapp} className="text-2xl sm:text-3xl text-white" />
    </ExternalLink>
  );
};

export default WhatsAppFloat;
